<template>
    <DataLabel
        v-tooltip
        item=""
        :class="stateClassName"
        :title="state.name">
        <slot />
        <small v-if="showLabel">{{ state.name }}</small>
    </DataLabel>
</template>

<script>
import DataLabel from '@/js/components/common/labels/DataLabel';

const textClassMap = {
    'awaiting': 'text-muted',
    'working': 'text-primary',
    'pending': 'text-warning-dark',
    'completed': 'text-success',
    'error': 'text-danger',
};

export default {
    name: 'StateLabel',

    components: {DataLabel},

    props: {
        state: {type: Object, required: true},
        showLabel: {type: Boolean},
    },

    computed: {
        stateClassName() {
            return textClassMap[this.state.id] || null;
        },
    },
};
</script>
